"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reset_service_area_modal_html_1 = __importDefault(require("./reset-service-area-modal/reset-service-area-modal.html"));
/**
 * Matches the filter value the API validates against; it is a student-list filter
 * rather than a real account status, but it shares the status dropdown.
 */
var MISSING_PERMIT_IMAGES_FILTER = "Missing Permit Images";
var AdminStudentsIndexController = /** @class */ (function () {
    function AdminStudentsIndexController($scope, $window, $uibModal, FlashService, UsersModel, ReportsModel, LocationsModel) {
        var _this = this;
        this.$scope = $scope;
        this.$window = $window;
        this.$uibModal = $uibModal;
        this.FlashService = FlashService;
        this.UsersModel = UsersModel;
        this.ReportsModel = ReportsModel;
        this.maxSize = 5;
        this.last_page = 0;
        this.page_by = 20;
        this.currentPage = 1;
        this.studentName = null;
        this.submitting = false;
        this.busy = false;
        this.start_date = null;
        this.end_date = null;
        this.sector = null;
        this.location = null;
        this.sort = null;
        this.selection = [];
        this.students = [];
        this.status = { name: "Active" };
        this.filterOptions = [
            { name: "All" },
            { name: "Inactive" },
            { name: "Unverified" },
            { name: "Active" },
            { name: "Unpaid Fees" },
            { name: MISSING_PERMIT_IMAGES_FILTER },
            { name: "Archived" },
        ];
        this.sortOptions = [
            {
                name: "Alphabetical A-Z",
                type: "lastname",
                direction: "asc",
            },
            {
                name: "Alphabetical Z-A",
                type: "lastname",
                direction: "desc",
            },
            {
                name: "Start Date (oldest first)",
                type: "start_date",
                direction: "asc",
            },
            {
                name: "Start Date (newest first)",
                type: "start_date",
                direction: "desc",
            },
        ];
        this.stats = {
            Active: 0,
            Unverified: 0,
            Archived: 0,
            Inactive: 0,
            "Unpaid Fees": 0,
        };
        this.getSearchParams = this.getSearchParams.bind(this);
        this.processStudents = this.processStudents.bind(this);
        this.handleStartDateDatepickerChange =
            this.handleStartDateDatepickerChange.bind(this);
        this.handleEndDateDatepickerChange =
            this.handleEndDateDatepickerChange.bind(this);
        // Build the filter options
        LocationsModel.getLocations().then(function (response) {
            _this.locations = response;
            _this.locations.unshift({ name: "All" });
            _this.sectors = response.flatMap(function (item) { return item.zoneparts || []; });
            _this.sectors.unshift({ name: "All" });
        });
        UsersModel.getStudents({
            page_by: this.page_by,
            status: "Active",
            withStats: true,
        }).then(function (result) {
            _this.students = result.students.data.filter(_this.processStudents);
            _this.last_page = result.students.last_page;
            _this.totalItems = result.students.total;
            _this.stats = result.stats;
        });
        this.$scope.$watch("vm.students|filter:{selected:true}", function (nv) {
            _this.selection = nv !== null && nv !== void 0 ? nv : [];
        }, true);
    }
    AdminStudentsIndexController.prototype.selectAll = function () {
        var _this = this;
        if (!this.students) {
            return;
        }
        this.students.forEach(function (student, index) {
            _this.students[index].selected = !_this.students[index].selected;
        });
    };
    AdminStudentsIndexController.prototype.bulkDelete = function () {
        var _this = this;
        if (this.busy || this.selection.length === 0) {
            return;
        }
        var confirmed = this.$window.confirm("Delete ".concat(this.selection.length, " student(s)? This cannot be undone."));
        if (!confirmed) {
            return;
        }
        this.busy = true;
        this.UsersModel.bulkDeleteStudents({
            students: this.selection.map(function (s) { return ({ id: s.id }); }),
        })
            .then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.applyFilter();
        })
            .finally(function () {
            _this.busy = false;
        });
    };
    AdminStudentsIndexController.prototype.bulkResetServiceArea = function () {
        var _this = this;
        if (this.busy || this.selection.length === 0) {
            return;
        }
        var modal = this.$uibModal.open({
            template: reset_service_area_modal_html_1.default,
            controller: "ResetServiceAreaModalController",
            controllerAs: "vm",
            resolve: {
                count: function () { return _this.selection.length; },
            },
        });
        modal.result.then(function () {
            _this.busy = true;
            _this.UsersModel.bulkResetStudentsServiceArea({
                students: _this.selection.map(function (s) { return ({ id: s.id }); }),
            })
                .then(function (response) {
                _this.FlashService.setMessage({
                    type: "success",
                    message: response.message,
                });
                _this.applyFilter();
            })
                .finally(function () {
                _this.busy = false;
            });
        });
    };
    AdminStudentsIndexController.prototype.handleStartDateDatepickerChange = function (newDatetime) {
        if (newDatetime.selected.length === 0) {
            this.start_date = null;
        }
        else {
            this.start_date = newDatetime.selected[0];
        }
    };
    AdminStudentsIndexController.prototype.handleEndDateDatepickerChange = function (newDatetime) {
        if (newDatetime.selected.length === 0) {
            this.end_date = null;
        }
        else {
            this.end_date = newDatetime.selected[0];
        }
    };
    AdminStudentsIndexController.prototype.processStudents = function (student) {
        if (student.default_school_location.length !== 0) {
            student.location = student.default_school_location[0].name;
        }
        if (student.default_sector.length !== 0) {
            student.zone = student.default_sector[0].name;
        }
        var params = this.getSearchParams(false, true);
        if (params.sector !== null && this.sector) {
            student.zone = this.sector.name;
        }
        return student;
    };
    /**
     * The permit-photo column only makes sense while that filter is the one
     * selected; every other filter returns students whose sides we did not ask for.
     */
    AdminStudentsIndexController.prototype.showingMissingPermitImages = function () {
        return !!this.status && this.status.name === MISSING_PERMIT_IMAGES_FILTER;
    };
    AdminStudentsIndexController.prototype.missingPermitImagesLabel = function (student) {
        var missing = student.missing_permit_images || [];
        return missing
            .map(function (side) { return (side === "front" ? "Front" : "Back"); })
            .join(" and ");
    };
    AdminStudentsIndexController.prototype.getSearchParams = function (getStats, removeNulls) {
        if (removeNulls === void 0) { removeNulls = true; }
        var params = {
            page_by: this.page_by,
            name: this.studentName,
            location: !this.location || this.location.name === "All"
                ? null
                : this.location.id,
            sector: !this.sector || this.sector.name === "All"
                ? null
                : this.sector.id,
            status: !this.status ? null : this.status.name,
            page: this.currentPage,
            sort_type: !this.sort ? null : this.sort.type,
            sort_direction: !this.sort ? null : this.sort.direction,
        };
        if (getStats === true) {
            params.withStats = true;
        }
        if (removeNulls === true) {
            params = Object.fromEntries(Object.entries(params).filter(function (_a) {
                var key = _a[0], value = _a[1];
                return value != null && value !== '';
            }));
        }
        if (!this.start_date) {
            delete params.start_date;
        }
        else {
            params.start_date = this.start_date.toLocaleDateString("en-US");
        }
        if (!this.end_date) {
            delete params.end_date;
        }
        else {
            params.end_date = this.end_date.toLocaleDateString("en-US");
        }
        return params;
    };
    AdminStudentsIndexController.prototype.pageChanged = function () {
        var _this = this;
        this.submitting = true;
        this.UsersModel.getStudents(this.getSearchParams(true, true))
            .then(function (result) {
            _this.students = result.students.data.filter(_this.processStudents);
            _this.stats = result.stats;
            _this.submitting = false;
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    AdminStudentsIndexController.prototype.applyFilter = function () {
        var _this = this;
        this.submitting = true;
        this.UsersModel.getStudents(this.getSearchParams(true, true))
            .then(function (result) {
            _this.students = result.students.data.filter(_this.processStudents);
            _this.totalItems = result.students.total;
            _this.stats = result.stats;
            _this.submitting = false;
        })
            .catch(function (Error) {
            _this.submitting = false;
        });
    };
    return AdminStudentsIndexController;
}());
AdminStudentsIndexController.$inject = [
    "$scope",
    "$window",
    "$uibModal",
    "FlashService",
    "UsersModel",
    "ReportsModel",
    "LocationsModel",
];
exports.default = AdminStudentsIndexController;
